var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileCheckbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#383838"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Signature applied"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 852,
    transform: "translate(-335 -705)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fields options",
    clipPath: "url(#clip0_986_1361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277497"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15.5,
    y: -15.5,
    width: 115,
    height: 47,
    rx: 11.5,
    stroke: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi_3188004"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -8,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E9E8ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-square_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.793 1.3335H5.20634C2.77967 1.3335 1.33301 2.78016 1.33301 5.20683V10.7868C1.33301 13.2202 2.77967 14.6668 5.20634 14.6668H10.7863C13.213 14.6668 14.6597 13.2202 14.6597 10.7935V5.20683C14.6663 2.78016 13.2197 1.3335 10.793 1.3335ZM11.1863 6.46683L7.40634 10.2468C7.31301 10.3402 7.18634 10.3935 7.05301 10.3935C6.91967 10.3935 6.79301 10.3402 6.69967 10.2468L4.81301 8.36016C4.61967 8.16683 4.61967 7.84683 4.81301 7.6535C5.00634 7.46016 5.32634 7.46016 5.51967 7.6535L7.05301 9.18683L10.4797 5.76016C10.673 5.56683 10.993 5.56683 11.1863 5.76016C11.3797 5.9535 11.3797 6.26683 11.1863 6.46683Z",
    fill: "#1E1341"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_986_1361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 48,
    fill: "white",
    transform: "translate(-323 -16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCheckbox);
export default __webpack_public_path__ + "static/media/MobileCheckbox.96f5c3eba0af048e60224ee86ad5bf6a.svg";
export { ForwardRef as ReactComponent };